import { PAYMENT_STATUS, isLegacyStripePaymentSystem, isStripeV2PaymentSystem } from './constants'

export default {
  getPaymentStatus() {
    return (status, method) => {
      const initialStatus = status.toUpperCase()

      if (method == 'Manual' && initialStatus === 'PENDING') {
        return {
          title: 'Awaiting payment',
          color: '#f59e0b'
        }
      }

      return PAYMENT_STATUS[initialStatus.toUpperCase()] ?? PAYMENT_STATUS.CREATED
    }
  },
  getPaymentSystem(state, _, rootState) {
    return id => {
      return rootState.applicationState.projectPaymentSystems.find(item => item.id === id)
    }
  },
  getPaymentTemplate(state) {
    return id => {
      return state.systemTemplates.find(item => item.id === id)
    }
  },
  getStripePaymentSystem(state, _, rootState) {
    const currentProjectId = rootState.applicationState.currentProject?.id

    if (!currentProjectId) {
      return () => undefined
    }

    return (id = null) => {
      const availableSystems = rootState.applicationState.projectPaymentSystems.filter(item => {
        const projectAssociation = (item.payment_system_project_association ?? []).find(
          project => project.project?.id === currentProjectId
        )

        return (
          projectAssociation &&
          projectAssociation.configs.enabled === true &&
          projectAssociation.configs.activated === true &&
          (isStripeV2PaymentSystem(item) || isLegacyStripePaymentSystem(item))
        )
      })

      if (id !== null) {
        return availableSystems.find(item => item.id === id)
      }

      return availableSystems.find(isStripeV2PaymentSystem) || availableSystems.find(isLegacyStripePaymentSystem)
    }
  }
}
